import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { AuthenticationDTO } from '../../model/AuthenticationDTO';
import { AuthService } from '../../../security/auth.service';
import { AudityService } from 'app/services/audity-service';
import { AudityDTO } from 'app/header-footer-template/model/AudityDTO';
import { CommonsUtils } from '../../../commons/CommonsUtils';
import { CommonsText } from 'app/commons/CommonsText';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {

  @Output() onAuthenticated = new EventEmitter();

  authenticationForm: FormGroup;
  authenticationDTO: AuthenticationDTO;
  messages: String[] = null;
  running: Boolean = false;
  showPassword = false;
  audity: AudityDTO = new AudityDTO();
  ipAddress: string;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private audityService: AudityService,
    private router: Router,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.authenticationDTO = new AuthenticationDTO();
    this.authenticationForm = this.formBuilder.group({
      username: [this.authenticationDTO.username, [Validators.required]],
      password: [this.authenticationDTO.password, [Validators.required, Validators.pattern(CommonsUtils.PASSWORD_REGEX)]]
    });

    this.authenticationForm.valueChanges.subscribe(() => { this.messages = null; });
    this.authService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res._body;
    });
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  submitEnabled() {
    return this.authenticationForm && this.authenticationForm.valid && !this.running;
  }

  onSubmit() {
    this.messages = [];
    if (!this.submitEnabled()) {
      return;
    }
    this.running = true;
    this.authService.onAuthenticate(this.authenticationForm.value)
      .then(success => {
        this.audity.audityDocument = this.authenticationForm.value.username;
        this.audity.audityIp = this.ipAddress;
        this.audityService.saveLogin(this.audity)
          .catch(error => {
            this.toastr.error(CommonsText.ERROR_SERVICIO_AUDITORIA, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
              timeOut: 5000
            });
          });
        this.authService.innovaLogin(this.authenticationForm.value)
          .then(success => {
            this.running = false;
            this.onAuthenticated.emit(true);
          })
          .catch(error => {
            this.audity.audityDocument = this.authenticationForm.value.username;
            this.audity.audityIp = this.ipAddress;
            this.running = false;
            const error_description = error.error.error_description;

            switch (error_description) {
              case 'BLOCKED_BY_RGPD': {
                this.audityService.saveLoginBlockedByRgpd(this.audity);
                this.messages = [CommonsText.BLOCKED_BY_RGPD];
                break;
              }
              case 'WITHOUT_POLICIES': {
                this.audityService.saveLoginWithoutPolicies(this.audity);
                this.messages = [CommonsText.WITHOUT_POLICIES];
                break;
              }
              default: {
                this.audityService.saveLoginIncorrectParameter(this.audity);
                this.messages = [CommonsText.PARAMETROS_INCORRECTOS];
                break;
              }
            }
          });
      })
      .catch(error => {
        this.audity.audityDocument = this.authenticationForm.value.username;
        this.audity.audityIp = this.ipAddress;
        this.running = false;
        const error_description = error.error.error_description;

        switch (error_description) {
          case 'DISABLED': {
            this.audityService.saveLoginDisabled(this.audity);
            this.messages = [CommonsText.DISABLED];
            break;
          }
          case 'BLOCKED': {
            this.audityService.saveLoginBlocked(this.audity);
            this.messages = [CommonsText.BLOCKED];
            break;
          }
          case 'BLOCKED_BY_RENEWAL': {
            this.audityService.saveLoginBlockedByRenewal(this.audity);
            this.messages = [CommonsText.BLOCKED_BY_RENEWAL];
            break;
          }
          default: {
            this.audityService.saveLoginIncorrectParameter(this.audity);
            this.messages = [CommonsText.PARAMETROS_INCORRECTOS];
            break;
          }
        }
      });
  }

  getButtonLabel() {
    return this.running ? CommonsText.CARGANDO : 'Continuar';
  }

  goToForgotPassword(event: Event) {
    event.preventDefault();
    this.router.navigate(['/forgot-password']);
  }

  goToRegister(event: Event) {
    event.preventDefault();
    this.router.navigate(['/register']);
  }
}
